import { createEntityAdapter, createSelector, createSlice } from "@reduxjs/toolkit";
import { nextId } from "../../utils";

const outputsAdapter = createEntityAdapter();

const initialState = outputsAdapter.getInitialState({
	tab: 0,
	fullDays: {sun: false, mon: false, tue: false, wed: false, thu: true, fri: false, sat: false},
	lightDays: {sun: false, mon: false, tue: true, wed: false, thu: false, fri: false, sat: true}
});

const outputsSlice = createSlice({
	name: "outputs",
	initialState,
	reducers: {
		clearOutputs(state) {
			const allIds = Object.values(state.entities).map((output) => output.id);
			outputsAdapter.removeMany(state, allIds);
		},
		loadInitial: outputsAdapter.upsertMany,
		addOutput(state, action) {
			const id = nextId(state.ids);
			const type = action.payload;
			const cost = {
				id,
				type,
				expense: "",
				noncp: 0.00,
				cp: 0.00,
				gdscp: 0.00,
				gdsnoncp: 0.00,
				booking: 0.00,
				expedia: 0.00,
				op35: 0.00,
				op50: 0.00
			};
			const weekly = {
				id,
				type,
				expense: "",
				sun: 0.00,
				mon: 0.00,
				tue: 0.00,
				wed: 0.00,
				thu: 0.00,
				fri: 0.00,
				sat: 0.00,
				total: 0.00
			};
			outputsAdapter.addOne(state, type === "cost" ? cost : weekly);
		},
		editOutput: outputsAdapter.updateOne,
		editOutputs: outputsAdapter.updateMany,
		deleteOutput(state, action) {
			outputsAdapter.removeOne(state, action.payload);
		},
		updateCheckbox(state, action) {
			const { type, prop, checked } = action.payload;
			state[type] = {...state[type], [prop]: checked};
		},
		setTab(state, action) {
			state.tab = action.payload;
		}
	}
})

export const {
	clearOutputs,
	loadInitial,
	addOutput,
	editOutput,
	editOutputs,
	deleteOutput,
	updateCheckbox,
	setTab
} = outputsSlice.actions;

export default outputsSlice.reducer

export const { selectAll: selectOutputs, selectById: selectOutputById } = outputsAdapter.getSelectors(state => state.channelMix.outputs);

export const selectOutputIdsByType = createSelector(
	selectOutputs,
	(state, type) => type,
	(outputs, type) => {
		const filtered = outputs.filter(output => output.type === type);
		return filtered.map(output => output.id);
	}
);

export const selectOutputTypeTotalByProp = createSelector(
	selectOutputs,
	(state, options) => options,
	(outputs, { prop, type }) => {
		const filtered = outputs.filter(output => output.type === type);
		return filtered.reduce((accumulator, object) => {
			return accumulator + object[prop];
		}, 0);
	}
);
